import React from 'react'
import { VIDEO_BASE } from '../../common/env';

interface Props { videoId: string, width?: string, height?: string, styles?: {} }

export function getVimeoVideoId(vimeoLink: string) {
    const match = vimeoLink.match(/(?:video\/|vimeo\.com\/)(\d+)/);

    return match ? match[1] : vimeoLink;
}

function VideoPlayer(props: Props) {
    const { videoId, width, height } = props
    const vimeoVideoId = getVimeoVideoId(videoId);

    return (
        <video
            src={VIDEO_BASE + vimeoVideoId}
            autoPlay={false}
            controls={true}
            style={{ ...props.styles, width: props.width ? width : '100%', height: props.height ? props.height : "100%" }}
        />
    );
}

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.tsx